/* eslint-disable import/no-internal-modules */
import axios from 'axios'
import {
  ContentType,
  getConsistentContentType
} from '@insided/shared/utils/contentType'

export interface UnifiedTopic {
  id: string
  contentType: string
  author: {
    id: string
  }
}

interface Topic {
  contentType: ContentType
  id?: string
  topicId?: string
  replyId?: string
}

function getIdFromTopic(topic: Topic) {
  if (topic.replyId) {
    return topic.replyId
  }
  if (topic.topicId) {
    return topic.topicId
  }
  return topic.id
}

export const getIdAndContentTypeFromTopics = (topics: any) =>
  topics.map((topic: Topic) => {
    topic.contentType = getConsistentContentType(topic.contentType)

    return {
      contentType: topic.replyId ? `${topic.contentType}_reply` : topic.contentType,
      id: Number(getIdFromTopic(topic))
    }
  }
  )

export const performBulkActionForTopics = async (topics: any, action: string) => {
  const selectedTopics = getIdAndContentTypeFromTopics(topics)

  await axios.post('/community/api/bulk/process', {
    action: action,
    topics: selectedTopics
  })
}
